/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type StepUpdateThreadMode = typeof StepUpdateThreadMode[keyof typeof StepUpdateThreadMode] | null;


export const StepUpdateThreadMode = {
  new_thread: 'new_thread',
  reply: 'reply',
} as const;
